import type { FeaturesSchema } from '@core/api/generated/types.gen'

export const exportOptions = ['qti', 'text', 'comptia', 'surpass', 'csv']
export const exportMathOptions = ['LaTeX', 'MathML'] as const
export const exportMathDelimiterOptions = ['\\(  \\)', '\\[  \\]', '$$  $$'] as const
export type ExportMathOptions = (typeof exportMathOptions)[number]
export type ExportMathDelimiter = (typeof exportMathDelimiterOptions)[number]

export type SkywardenSearchMode = NonNullable<FeaturesSchema['skywarden_search_mode']>
export type SkywardenFusionStrategy = NonNullable<FeaturesSchema['skywarden_fusion_strategy']>
export const skywardenSearchModeOptions: SkywardenSearchMode[] = ['vector', 'hybrid', 'text']
export const skywardenFusionStrategyOptions: SkywardenFusionStrategy[] = [
  'rrf',
  'weighted',
  'boost',
]

export type features =
  | 'read'
  | 'trust_vote'
  | 'possible_keys'
  | 'rationales'
  | 'pretest_key'
  | 'pretest_content'
  | 'pretest_style'
  | 'pretest_bias'

export type permissionFlags =
  | 'read'
  | 'trustVote'
  | 'possibleKeys'
  | 'rationales'
  | 'pretestKey'
  | 'pretestContent'
  | 'pretestStyle'
  | 'pretestBias'

export const pretestOptions: { label: string; value: features; key: permissionFlags }[] = [
  { label: 'Key', value: 'pretest_key', key: 'pretestKey' },
  { label: 'Content', value: 'pretest_content', key: 'pretestContent' },
  { label: 'Style', value: 'pretest_style', key: 'pretestStyle' },
  { label: 'Bias', value: 'pretest_bias', key: 'pretestBias' },
]

export type PreTestFeatures = {
  pretest_bias?: boolean
  pretest_content?: boolean
  pretest_key?: boolean
  pretest_style?: boolean
}

export type FeaturesByModel = {
  editor_images: boolean
  editor_wolfram: boolean
  editor_math_all: boolean
  editor_math_finance: boolean
  editor_desmos: boolean
}

export type ExportDownloadFilenameConvention =
  | 'content_first'
  | 'date_first'
  | 'simple_descriptive'
  | 'concatenated_names'

export type CustomerFeatures = {
  export_file?: typeof exportOptions
  export_math?: ExportMathOptions | string
  export_math_delimiter?: ExportMathDelimiter | string
  use_identifier_for_exports?: boolean
  images_zip_file_export?: boolean
  learn_v2?: boolean
  possible_keys?: boolean
  rationales?: boolean
  probuilder_integration?: boolean
  generate_math?: boolean
  item_types_v2?: boolean
  model_type_filter?: boolean
  webhook_integration?: boolean
  export_download_filename_convention?: ExportDownloadFilenameConvention
  language_selector?: boolean
  skywarden_search_mode?: SkywardenSearchMode
  skywarden_fusion_strategy?: SkywardenFusionStrategy
  skywarden_fusion_weight?: number
}

export type FormValues = {
  hasOptionRationale: boolean
  features: CustomerFeatures & PreTestFeatures
}
